<template>
    <div>
        <v-fab-transition>
            <v-btn @click="showTutorial = true" v-show="!showTutorial" fixed top right dark fab small color="#16414c">
                <v-icon>fas fa-question</v-icon>
            </v-btn>
        </v-fab-transition>

        <v-fab-transition>
            <v-btn @click="showTutorial = false" v-show="showTutorial" fixed top right dark fab small color="#16414c">
                <v-icon>fas fa-times</v-icon>
            </v-btn>
        </v-fab-transition>

        <v-expand-transition>
            <v-container pa-0 fluid v-if="showTutorial">
                <v-card tile color="#16414c">
                    <v-card-text>
                        <v-layout row style="height: 100px" align-top justify-center :pt-5="$vuetify.breakpoint.xsOnly" :pt-2="$vuetify.breakpoint.smAndUp">
                            <v-flex xs10 md6 class="text-md-center">
                                <div class="hb-heading headline"><v-icon size="24" style="padding-bottom: 2px; margin-right: 5px; color: rgba(0,0,0,0.3)">fas fa-rocket</v-icon> Opastus</div>
                                <p class="body-3">{{ helpText[currentStep] }}</p>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-layout row grid>
                            <v-flex xs12 class="text-md-center" pb-3>
                                <v-btn :class="{'ml-0': $vuetify.breakpoint.smAndDown}" :disabled="currentStep === 0" small flat @click="previousTutorialStep">Edellinen</v-btn>
                                <v-btn v-if="currentStep < (helpText.length - 1)" small flat @click="nextTutorialStep">Seuraava</v-btn>
                                <v-btn v-if="currentStep === (helpText.length - 1)" small flat @click="showTutorial = false">Sulje</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-actions>
                    <v-progress-linear
                            :value="tutorialProgress"
                            class="my-0"
                            color="#24758a"
                            height="3"
                    ></v-progress-linear>
                </v-card>
            </v-container>
        </v-expand-transition>
    </div>
</template>

<script>
    import Math from 'mathjs';

    export default {
    name: "Tutorial",
    data() {
      return {
        helpText: [
          'Opeta tekoälyä koneesi kameralla ja pelkällä selaimella. Koodausta ei tarvita.\nHUOM! Kuvia ei lähetetä mihinkään.',
          'Tämä kokeilu demonstroi kuinka yhden osa-alueen tekoäly toimii. Voit opettaa tekoälyä kamerasi avulla ja se vastaa hauskalla tavalla.',
          'Vasemmalla näkyy ”Syöte”, jossa pitäisi näkyä kameran kuva. Selaimelle pitää tietysti antaa oikeus käyttää kameraa.',
          'Keskellä näkyy luokat. Sininen, punainen ja vihreä.',
          'Oikealla näkyy ”Tulos”, kuinka tekoäly vastaa opetettujen luokkien perusteella.',
          'Nosta vaikka kätesi ylös ja paina sinistä harjoituspainiketta muutaman sekunnin.',
          'Sinun pitäisi nähdä sininen varmuuspalkki ja koiran kuva.',
          'Vaikka lasket käden, näet koiran joka tapauksessa.\nTekoäly vertaa opetettuja syötteitä ja valitsee mikä luokka vastaa parhaiten syötettä.',
          'Mutta koska olet opettanut vain sinisen luokan, se on aina valittuna.\nSinun pitää opettaa toinenkin syöte vastaamaan esim. punaista luokkaa.',
          'Istu kädet alhaalla ja paina punaista harjoituspainiketta muutaman sekunnin.',
          'Liikuta kättä ylös ja alas. Sinun pitäisi nähdä koira, kun käsi on ylhäällä ja vuohi kun käsi on alhaalla.',
          'Vihreä painike toimii samalla tavalla. Kokeile opettamista ja muista että kuvia ei lähetetä mihinkään. Kaikki tapahtuu omalla koneellasi.',
          'Tarkkuutta voi lisätä ottamalla enemmän opetuskuvia ja hieman eri kulmista.\nTyypillisesti jo noin 30 kuvalla pääsee hyviin tuloksiin.',
        ],
        currentStep: 0,
        showTutorial: true,
      }
    },
    methods: {
      previousTutorialStep() {
        if (this.currentStep > 0) this.currentStep--;
      },
      nextTutorialStep() {
        if (this.currentStep < (this.helpText.length - 1)) this.currentStep++;
      },
    },
    computed: {
      tutorialProgress() {
        return Math.multiply(Math.divide((this.currentStep + 1), this.helpText.length), 100);
      },
    },
    }
</script>

<style scoped>
    .body-3 {
        font-size: 18px;
        font-weight: 300;
    }
</style>